module.exports = __webpack_public_path__ + "static/avatarphoto-removebg-preview-2f4acb7aebb4cd9b02a7010b730e7b98.png";